export default __webpack_public_path__ + "static/media/In_case_of_emergency.3be9c2a8.pdf";